import request from "../utils/request";

export function GET_RoleList(token) {
  return request.get("/Auth/Role/List", null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function GET_RoleDetail(token, payload) {
  return request.get("/Auth/Role", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function POST_Role(token, payload) {
  return request.post("/Auth/Role", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function PUT_Role(token, payload) {
  return request.put("/Auth/Role", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function DELETE_Role(token, payload) {
  return request.delete("/Auth/Role", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function GET_RolePermissions(token) {
  return request.get("/Auth/Permission/List", null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function GET_RolePermissionsByUser(token) {
  return request.get("/Auth/RolePermissions", null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
